import React from "react";
import styles from "./AnalyticsCard.module.css";

export default function AnalyticsCard({ title, children }) {
    return (
        <div className={styles.card}>
            {title && <div className={styles.header}>{title}</div>}
            <div className={styles.content}>
                {children}
            </div>
        </div>
    );
}
